class groups {
  constructor(id, name, idSon, son, level) {
    this.id = id;
    this.name = name;
    this.idSon = idSon;
    this.son = son;
    this.level = level;
  }

  get hasAParent() {
    return this.id !== null;
  }

  get root() {
    return this.level === 0;
  }

  static fromJson({ padre, nombreP, hijo, nombreH, nivel }) {
    return new groups(padre, nombreP, hijo, nombreH, nivel);
  }
}

export default groups;
